const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useProgress } = window.BAO.Carousel.plugins

class CollectionCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        disabled: true,
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.4,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: false,
            slides: {
              perView: 2.2,
              spacing: 20,
            },
          }
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('collection-carousel')) {
  customElements.define('collection-carousel', CollectionCarousel)
}
